module.exports = __webpack_public_path__ + "static/media/writing.e518dd84.png";